import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import utils from 'utils';
import { getFormattedDate } from 'dateUtils';
import { timeLabelMapper } from 'data/timeOptions';
import CalendarIcon from 'icons/Calendar.icon';

import './EoiDate.styles.scss';

type EoiDateProps = {
  className?: string;
  seekingExpressionOfInterestDate: string;
  bigger?: boolean;
};

const EoiDate: React.FC<EoiDateProps> = (props) => {
  const { className, seekingExpressionOfInterestDate, bigger = false } = props;
  const { t } = useTranslation();
  const classes = classNames('eoi-date', className, {
    'eoi-date--bigger': bigger,
  });

  const eoiDate = useMemo(() => {
    if (!seekingExpressionOfInterestDate) return null;

    const { day, week, hour, seconds, isFuture, getCount } =
      utils.getDateVariables(new Date(seekingExpressionOfInterestDate));

    if (!isFuture) return null;

    let eoiDate;

    const hoursLeft = getCount(hour);
    const { hours } = utils.getTimeFromUserTimezone(
      seekingExpressionOfInterestDate,
    );

    //if there is less that 24h left till end and the date is the current date
    if (seconds < day && hoursLeft < hours && !!hours)
      eoiDate = t('eoiTodayHour', { time: timeLabelMapper[hours] });
    else if (seconds < day)
      eoiDate = t('eoiTomorrowHour', {
        time: timeLabelMapper[hours],
      });
    else if (seconds < day * 7) {
      eoiDate = t('eoiDueDays', { count: getCount(day) });
    } else if (seconds === week) {
      eoiDate = t('eoiDueWeek');
    } else {
      eoiDate = t('eoiDue', {
        date: getFormattedDate(new Date(seekingExpressionOfInterestDate)),
      });
    }

    return eoiDate;
  }, [seekingExpressionOfInterestDate, t]);

  if (!eoiDate) return null;

  return (
    <p className={classes}>
      <CalendarIcon />
      {eoiDate}
    </p>
  );
};

export default EoiDate;
